// lazyRecharts.js
import React, { lazy } from "react";

// Generic lazy loader for Recharts components
const lazyRecharts = (name) =>
  lazy(() => import("recharts").then(mod => ({ default: mod[name] })));

// Default colors palette
const DEFAULT_COLORS = ["#10b981", "#f59e0b", "#ef4444", "#3b82f6", "#8b5cf6"];

// --- Export lazy-loaded components ---
export const BarChart = lazyRecharts("BarChart");
export const ResponsiveContainer = lazyRecharts("ResponsiveContainer");
export const PieChart = lazyRecharts("PieChart");
export const Line = lazyRecharts("Line");
export const LineChart = lazyRecharts("LineChart");
export const LabelList = lazyRecharts("LabelList");
export const Legend = lazyRecharts("Legend");

// Lazy wrapper for Bar with default color
export const Bar = lazy(() =>
  import("recharts").then(mod => {
    const OriginalBar = mod.Bar;
    const WrappedBar = (props) => (
      <OriginalBar {...props} fill={props.fill || DEFAULT_COLORS[0]} />
    );
    return { default: WrappedBar };
  })
);

export { Pie, Cell } from "recharts";

export const Tooltip = lazy(() => import("recharts/es6/component/Tooltip").then(mod => ({ default: mod.Tooltip })));
export const XAxis = lazy(() => import("recharts/es6/cartesian/XAxis").then(mod => ({ default: mod.XAxis })));
export const YAxis = lazy(() => import("recharts/es6/cartesian/YAxis").then(mod => ({ default: mod.YAxis })));

export const CartesianGrid = lazy(() => import("recharts/es6/cartesian/CartesianGrid").then(mod => ({ default: mod.CartesianGrid })));
